import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { TERM_TIPS } from "@/lib/helpContent";

// A discoverable circled "i" button next to a term. Click / tap / keyboard-focus opens a
// short explanation in a readable popover. Escape or outside-click dismisses. Accessible
// (focusable button + aria-label); never hover-only.
export function InfoTip({ topic, dark = false, side = "top", className = "" }) {
  const t = TERM_TIPS[topic];
  if (!t) return null;
  const color = dark
    ? "text-white/75 hover:text-white"
    : "text-brand hover:text-brand/70";
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={`info-tip-${topic}`}
          aria-label={`About ${t.title}`}
          onClick={(e) => e.stopPropagation()}
          className={`inline-flex items-center justify-center align-middle shrink-0 h-[18px] w-[18px] rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-1 ${color} ${className}`}
        >
          <Info size={17} strokeWidth={2.25} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side={side}
        align="start"
        onClick={(e) => e.stopPropagation()}
        className="w-72 max-w-[86vw] z-50 text-left p-3.5"
        data-testid={`info-tip-popover-${topic}`}
      >
        <p className="font-heading font-semibold text-navy text-sm">{t.title}</p>
        <p className="mt-1 text-sm text-[#334155] leading-relaxed">{t.body}</p>
      </PopoverContent>
    </Popover>
  );
}
